import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { SidePanelType } from 'models/side_panel';

export default class ToggleSidebarCollapse {
  constructor(context) {
    this.context = context;
  }

  run({ windowWidth }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.toggleShouldCollapseSidebar();
    setAgentPreferences(this.context, preferences);

    const sidePanel = this.context.stores.sidePanel.get();
    this.context.analytics.track('Customer List Collapse Toggled', {
      collapsed: preferences.shouldCollapseSidebar,
      isAnswerPanelOpen: sidePanel.isShowing(SidePanelType.ANSWER),
      isTaskPanelOpen: sidePanel.isShowing(SidePanelType.TASK),
      windowWidth,
    });
  }
}
